"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setNestedValue = exports.getNestedValue = exports.SST_VESSEL_FIELD_MAP = exports.SSTAmendmentDTO = exports.SSTAmendmentDTOSchema = exports.SSTAmendmentRequestSchema = exports.SSTAmendmentBaseSchema = exports.SSTAmendmentSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
exports.SSTAmendmentSchema = zod_1.z.object({
    sstId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    adminUserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    fieldPath: zod_1.z.string().min(1, 'Field path is required'),
    fieldLabel: zod_1.z.string().min(1, 'Field label is required'),
    originalValue: zod_1.z.any().nullable(), // Allow null for fields that don't exist
    newValue: zod_1.z.any().nullable(),
    reason: zod_1.z.string().min(10, 'Amendment reason must be at least 10 characters'),
    status: zod_1.z.enum(['applied', 'failed']).default('applied'),
    appliedAt: zod_1.z.date().default(function () { return new Date(); }),
});
exports.SSTAmendmentBaseSchema = exports.SSTAmendmentSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
// DTO for amendment requests
exports.SSTAmendmentRequestSchema = zod_1.z.object({
    fieldPath: zod_1.z.string(),
    fieldLabel: zod_1.z.string(),
    newValue: zod_1.z.any().nullable(),
    originalValue: zod_1.z.any().nullable(),
});
// DTO for amendment responses
exports.SSTAmendmentDTOSchema = zod_1.z.object({
    _id: zod_1.z.string(),
    sstId: zod_1.z.string(),
    adminUserId: zod_1.z.string(),
    fieldPath: zod_1.z.string(),
    fieldLabel: zod_1.z.string(),
    originalValue: zod_1.z.any().nullable(),
    newValue: zod_1.z.any().nullable(),
    reason: zod_1.z.string(),
    status: zod_1.z.string(),
    appliedAt: zod_1.z.date(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
exports.SSTAmendmentDTO = {
    convertFromModel: function (model) {
        return {
            _id: model._id.toString(),
            sstId: model.sstId.toString(),
            adminUserId: model.adminUserId.toString(),
            fieldPath: model.fieldPath,
            fieldLabel: model.fieldLabel,
            originalValue: model.originalValue,
            newValue: model.newValue,
            reason: model.reason,
            status: model.status,
            appliedAt: model.appliedAt,
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
        };
    },
};
// Field mapping utility
exports.SST_VESSEL_FIELD_MAP = {
    // Vessel fields
    'vessel.vesselType': 'Vessel Type',
    'vessel.name': 'Vessel Name',
    'vessel.flag': 'Flag',
    'vessel.officialNumber': 'Official Number',
    'vessel.imoNumber': 'IMO Number',
    'vessel.length': 'Length (m)',
    'vessel.grossTonnage': 'Gross Tonnage (GT)',
    'vessel.mainEngineType': 'Main Engine Type',
    'vessel.mainEnginePower': 'Main Engine Power',
    'vessel.kw': 'Power (kW)',
    // Signatory fields
    'responsiblePerson.firstName': 'Signatory First Name',
    'responsiblePerson.middleName': 'Signatory Middle Name',
    'responsiblePerson.lastName': 'Signatory Last Name',
    'responsiblePerson.capacity': 'Signatory Capacity',
    'responsiblePerson.email': 'Signatory Email',
    'responsiblePerson.cocNo': 'Signatory CoC Number',
    'responsiblePerson.cocAuthority': 'Signatory CoC Authority',
    'responsiblePerson.yachtName': 'Signatory Yacht Name',
    // Type & Capacity
    testimonialType: 'SST Type',
    // Seafarer fields
    'seafarer.capacity': 'Seafarer Capacity',
    // Service Data fields (dates and days)
    dateFrom: 'Service Start Date',
    dateTo: 'Service End Date',
    actualDays: 'Actual Days at Sea',
    daysLeave: 'Days of Leave',
    leaveDates: 'Leave of Absence Dates',
    daysStandBy: 'Stand-by Service Days',
    daysShipyard: 'Shipyard Service Days',
    daysWatchKeeping: 'Deck Watchkeeping Days',
    daysSeagoingWatchKeeping: 'Engineering Watchkeeping Days',
    daysAdditionalWatchKeeping: 'Additional Watchkeeping Days',
    nightWatchHours: 'Night Watch Hours',
    // Additional fields
    nauticalMiles: 'Nautical Miles',
    daysGuests: 'Days with Guests',
    rotationProgram: 'Rotation Program',
    areasCruised: 'Areas Cruised',
    additionalInformation: 'Sea Service Description and Shipyard Worklist',
};
// Utility functions for nested object manipulation
var getNestedValue = function (obj, path) {
    return path.split('.').reduce(function (current, key) { return current === null || current === void 0 ? void 0 : current[key]; }, obj);
};
exports.getNestedValue = getNestedValue;
var setNestedValue = function (obj, path, value) {
    var keys = path.split('.');
    var lastKey = keys.pop();
    if (!lastKey)
        return;
    var target = keys.reduce(function (current, key) {
        if (!current[key] || typeof current[key] !== 'object') {
            current[key] = {};
        }
        return current[key];
    }, obj);
    target[lastKey] = value;
};
exports.setNestedValue = setNestedValue;
//# sourceMappingURL=SSTAmendment.js.map